const choices = {
    primaryAndSecondaryStudies: 'Études primaires/secondaires',
    university: 'Études supérieures',
    active: 'Vie active',
};

export default choices;
